import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (v: { title: string; qualifier?: string }) => void;
  initial: { title: string; qualifier?: string };
};

const SurveyQuestionPillarModal: React.FC<Props> = ({ open, onClose, onSave, initial }) => {
  const [title, setTitle] = useState(initial.title || '');
  const [qualifier, setQualifier] = useState(initial.qualifier || '');

  useEffect(() => {
    if (open) {
      setTitle(initial.title || '');
      setQualifier(initial.qualifier || '');
    }
  }, [open, initial]);

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>Edit EDI Question</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Input label="Qualifier" value={qualifier} onChange={(_, { value }) => setQualifier(String(value))} />
          <Form.Input label="Title" value={title} onChange={(_, { value }) => setTitle(String(value))} />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
        <Button primary onClick={() => onSave({ title, qualifier: qualifier || undefined })}>Save</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default SurveyQuestionPillarModal;
